// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"415b481d","239":"e5def2fd","453":"17001363","455":"b015c811"}[chunkId] + ".chunk.js";
};